module.exports = __webpack_public_path__ + "img/withdrawl-slide.b5ce9571.svg";